export enum AddictionKeys {
    MENTAL_COMPLETE = "AddictionMENTAL_COMPLETE",
    PHYSICAL_COMPLETE = "AddictionPHYSICAL_COMPLETE",
    CRAVINGS_AND_WITHDRAWAL_COMPLETE = "AddictionCRAVINGS_AND_WITHDRAWAL_COMPLETE",
    NICOTINE_AND_ADDICTION_COMPLETE = "AddictionNICOTINE_AND_ADDICTION_COMPLETE",
}

export class AddictionRepo {
    private static innerInstance: AddictionRepo
    private addictionCompletedStages: Array<AddictionKeys> = []

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    static destroy() {
        return this.innerInstance = null
    }

    isMentalComplete(): boolean {
        return this.addictionCompletedStages.includes(AddictionKeys.MENTAL_COMPLETE)
    }

    setMentalAsComplete() {
        this.addictionCompletedStages.push(AddictionKeys.MENTAL_COMPLETE)
    }

    isPhysicalComplete(): boolean {
        return this.addictionCompletedStages.includes(AddictionKeys.PHYSICAL_COMPLETE)
    }

    setPhysicalAsComplete() {
        this.addictionCompletedStages.push(AddictionKeys.PHYSICAL_COMPLETE)
    }

    isCravingsAndWithdrawalComplete(): boolean {
        return this.addictionCompletedStages.includes(AddictionKeys.CRAVINGS_AND_WITHDRAWAL_COMPLETE)
    }

    setCravingsAndWithdrawalAsComplete() {
        this.addictionCompletedStages.push(AddictionKeys.CRAVINGS_AND_WITHDRAWAL_COMPLETE)
    }

    isNicotineAndAddictionComplete(): boolean {
        return this.addictionCompletedStages.includes(AddictionKeys.NICOTINE_AND_ADDICTION_COMPLETE)
    }

    setNicotineAndAddictionAsComplete() {
        this.addictionCompletedStages.push(AddictionKeys.NICOTINE_AND_ADDICTION_COMPLETE)
    }

}
